import { IGanttSeries } from "@directives/_visualisations/ganttChart/ganttChart.component";
import { IJourney, IJourney as IJourney1 } from "@interfaces/IJourney";
import { GanttSeriesService } from "@services/ganttSeries.service";
import { IHistoricalDay } from "@services/journey.service";
import * as angular from "angular";
import * as moment from "moment";
import "./driverTachoSummary.scss";

class VehicleHistoryGanttChartComponentController implements angular.IComponentController {

    loading = false;

    historicalDay: IHistoricalDay;
    ganttChartSeries: IGanttSeries[];

    onJourneyHover: (args: { journey: IJourney }) => void;
    onJourneyClick: (args: { journey: IJourney }) => void;
    onMouseMove: (args: { time: moment.Moment }) => void;

    static $inject = ["ganttSeriesService", "reasonCodeService"];

    constructor(
        private readonly ganttSeriesService: GanttSeriesService
    ) {
    }

    $onChanges?(onChangesObj: angular.IOnChangesObject) {
        if (onChangesObj["historicalDay"] && this.historicalDay) {
            this.createGanttSeries();
        }
    }

    onGanttMouseMove(time: moment.Moment) {
        const journeyUnderMouse = this.getJourneyAtTime(time);

        if (this.onJourneyHover) {
            this.onJourneyHover({ journey: journeyUnderMouse });
        }

        if (this.onMouseMove) {
            this.onMouseMove({ time: time });
        }
    }

    onGanttMouseClick(time: moment.Moment) {

        const journeyUnderMouse = this.getJourneyAtTime(time);

        if (this.onJourneyClick) {
            this.onJourneyClick({ journey: journeyUnderMouse });
        }
    }

    // ------------------------

    private getJourneyAtTime(time: moment.Moment): IJourney1 {
        var foundJourney = null;

        this.historicalDay.journeyModel.journeys.forEach(journey => {
            if (time.isBetween(moment(journey.StartUtc), moment(journey.EndUtc))) {
                foundJourney = journey;
            }
        });
        
        return foundJourney;
    }

    private createGanttSeries(): any {
        this.ganttChartSeries = [];

        this.ganttChartSeries.push(this.ganttSeriesService.createJourneySeries(this.historicalDay));
    }
}

export class VehicleHistoryGanttChartComponent implements angular.IComponentOptions {

    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            historicalDay: "<",
            onJourneyHover: "&",
            onJourneyClick: "&",
            onMouseMove: "&"
        };

        this.controller = VehicleHistoryGanttChartComponentController;
        this.template = require("./vehicleHistoryGanttChart.html");
    }
}
